import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqData } from "@/config/constants";

export const FAQSection = ({ sectionRef, isVisible, onOpenPalpiteModal }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="font-heading text-3xl md:text-4xl text-[#002776]">
            DÚVIDAS FREQUENTES
          </h2>
        </div>
        
        <Accordion type="single" collapsible className="space-y-3">
          {faqData.map((faq) => (
            <AccordionItem key={faq.id} value={faq.id} className="bg-gray-50 rounded-2xl px-5 border-none">
              <AccordionTrigger className="text-left font-semibold text-[#002776] hover:text-[#009C3B] py-4 hover:no-underline text-sm">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-4 text-sm">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        {/* CTA após FAQ */}
        <div className="mt-8 text-center">
          <button
            onClick={onOpenPalpiteModal}
            className="bg-[#009C3B] hover:bg-[#007830] text-white font-bold py-4 px-8 rounded-xl shadow-xl transition-all transform hover:scale-105 animate-pulse-cta"
            data-testid="faq-cta-button"
          >
            QUERO GARANTIR MEU PASSEIO E FAZER MEU PALPITE
          </button>
          <p className="text-gray-500 text-xs mt-2">R$97 para 1 pessoa • 12 meses de validade</p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
